export type AppointmentStatus =
  | 'scheduled'
  | 'confirmed'
  | 'reminded'
  | 'rescheduled'
  | 'cancelled'
  | 'completed'
  | 'no_show';

export interface AppointmentStatusOption {
  value: AppointmentStatus;
  label: string;
  color: string;
  description: string;
}

export const APPOINTMENT_STATUS_OPTIONS: AppointmentStatusOption[] = [
  {
    value: 'scheduled',
    label: 'Programmato',
    color: '#94a3b8',
    description:
      'Appuntamento creato in agenda. Slot riservato ma il cliente non ha ancora confermato. Stato iniziale di default.',
  },
  {
    value: 'confirmed',
    label: 'Confermato',
    color: '#3b82f6',
    description:
      'Il cliente (o l\'operatore) ha confermato la presenza. Triggera le automazioni "post-conferma" e blocca lo slot dalle riassegnazioni automatiche.',
  },
  {
    value: 'reminded',
    label: 'Promemoria inviato',
    color: '#a855f7',
    description:
      'Aggiornato automaticamente quando un\'automazione di promemoria (WhatsApp / SMS / email / voce) viene consegnata con successo.',
  },
  {
    value: 'rescheduled',
    label: 'Riprogrammato',
    color: '#f59e0b',
    description:
      'L\'appuntamento è stato spostato a una nuova data o orario. Mantiene la storia dell\'evento originale per analytics e SLA.',
  },
  {
    value: 'completed',
    label: 'Completato',
    color: '#10b981',
    description:
      'Appuntamento avvenuto e chiuso correttamente. Sblocca le automazioni "post-appuntamento" (review, follow-up, cross-sell).',
  },
  {
    value: 'cancelled',
    label: 'Annullato',
    color: '#ef4444',
    description:
      'Annullato dal cliente o dall\'operatore. Lo slot torna libero ed eventuali riassegnazioni vengono bloccate.',
  },
  {
    value: 'no_show',
    label: 'Non presentato',
    color: '#6b7280',
    description:
      'Il cliente non si è presentato. Conta nelle metriche di no-show e può triggerare workflow di recall o penalty.',
  },
];

export const APPOINTMENT_STATUSES: AppointmentStatus[] =
  APPOINTMENT_STATUS_OPTIONS.map((s) => s.value);

export const APPOINTMENT_STATUS_LABELS: Record<AppointmentStatus, string> =
  APPOINTMENT_STATUS_OPTIONS.reduce((acc, s) => {
    acc[s.value] = s.label;
    return acc;
  }, {} as Record<AppointmentStatus, string>);

export const APPOINTMENT_STATUS_COLORS: Record<AppointmentStatus, string> =
  APPOINTMENT_STATUS_OPTIONS.reduce((acc, s) => {
    acc[s.value] = s.color;
    return acc;
  }, {} as Record<AppointmentStatus, string>);
